/* MOOVE Slimming PDP: smaakkiezer + packs + abonnement. Zie snippets/slimming-kiezer.liquid */
(function () {
  function fmt(cents, format) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    if (!format) return '€' + withComma;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals') return String(Math.round(cents / 100));
      return v;
    });
  }

  function init(root) {
    if (root.dataset.skReady) return;
    root.dataset.skReady = '1';

    var flavors = JSON.parse(root.querySelector('[data-sk-data]').textContent);
    var F = {};
    flavors.forEach(function (f) { F[f.handle] = f; });
    var pct2 = parseInt(root.dataset.pct2, 10) || 0;
    var pct3 = parseInt(root.dataset.pct3, 10) || 0;
    var plan = root.dataset.plan;
    var money = root.dataset.moneyFormat;

    var page = root.closest('[data-js-product-component]') || document;
    var form = page.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.disabled = true;
    form.querySelectorAll('[name="quantity"]').forEach(function (el) { el.disabled = true; });
    var holder = document.createElement('div');
    holder.hidden = true;
    form.appendChild(holder);
    var atcText = form.querySelector('[data-js-product-add-to-cart-text]');
    var atcBtn = form.querySelector('[data-js-product-add-to-cart]');

    var checkedTile = root.querySelector('.sk__tile input:checked');
    var state = {
      flavor: checkedTile ? checkedTile.value : flavors[0].handle,
      packs: parseInt((root.querySelector('.sk__row-main input:checked') || {}).value || '2', 10),
      list: [],
      sub: false
    };
    state.list = fill([], state.packs, state.flavor);

    function fill(list, n, handle) {
      var out = list.slice(0, n);
      while (out.length < n) out.push(handle);
      return out;
    }

    function lines(list) {
      var map = {}, order = [];
      list.forEach(function (h) {
        if (!map[h]) { map[h] = 0; order.push(h); }
        map[h]++;
      });
      return order.map(function (h) { return { handle: h, qty: map[h] }; });
    }

    function pctFor(n) { return n >= 3 ? pct3 : (n === 2 ? pct2 : 0); }

    function price(list, sub) {
      var full = 0, now = 0;
      lines(list).forEach(function (l) {
        var f = F[l.handle];
        var lineFull = f.price * l.qty;
        full += lineFull;
        if (sub) now += f.sub * l.qty;
        // Shopify rondt de korting per stuk naar beneden af (getest 30 sep 2026), dus zo rekenen wij ook.
        else now += (f.price - Math.floor(f.price * pctFor(list.length) / 100)) * l.qty;
      });
      var save = full > now ? Math.round((full - now) * 100 / full) : 0;
      return { full: full, now: now, save: save };
    }

    function imgs(el, list) {
      el.innerHTML = '';
      list.forEach(function (h) {
        var img = document.createElement('img');
        img.src = F[h].img; img.alt = ''; img.width = 38; img.height = 44; img.loading = 'lazy';
        el.appendChild(img);
      });
    }

    function render() {
      var cur = price(state.list, state.sub);
      root.querySelector('[data-sk-price]').textContent = fmt(cur.now, money);
      root.querySelector('[data-sk-flavor-name]').textContent = F[state.flavor].name;

      root.querySelectorAll('.sk__tile input').forEach(function (i) { i.checked = i.value === state.flavor; });

      root.querySelectorAll('[data-sk-row]').forEach(function (row) {
        var n = parseInt(row.dataset.skRow, 10);
        var active = n === state.packs;
        var list = active ? state.list : fill(state.list, n, state.flavor);
        var p = price(list, state.sub);
        row.classList.toggle('is-active', active);
        row.querySelector('.sk__row-main input').checked = active;
        imgs(row.querySelector('[data-sk-row-imgs]'), list);
        row.querySelector('[data-sk-row-now]').textContent = fmt(p.now, money);
        row.querySelector('[data-sk-row-compare]').textContent = p.save ? fmt(p.full, money) : '';
        row.querySelector('[data-sk-row-save]').textContent = p.save ? 'Bespaar ' + p.save + '%' : '';
        row.querySelectorAll('[data-sk-pack]').forEach(function (sel) {
          var h = list[parseInt(sel.dataset.skPack, 10)];
          sel.value = h;
          var wrap = sel.closest('.sk__select');
          wrap.querySelector('[data-sk-sel-img]').src = F[h].img;
          wrap.querySelector('[data-sk-sel-name]').textContent = F[h].name;
        });
      });

      holder.innerHTML = '';
      lines(state.list).forEach(function (l, i) {
        add('items[' + i + '][id]', F[l.handle].variant);
        add('items[' + i + '][quantity]', l.qty);
        if (state.sub && plan) add('items[' + i + '][selling_plan]', plan);
      });

      var ok = state.list.every(function (h) { return F[h].available; });
      if (atcBtn) atcBtn.classList.toggle('disabled', !ok);
      if (atcText) atcText.textContent = root.dataset.atcLabel + ' · ' + fmt(cur.now, money);

      updatePoints(Math.ceil(cur.now / 100));

      page.querySelectorAll('[data-sk-flavor]').forEach(function (el) {
        el.hidden = el.dataset.skFlavor !== state.flavor;
      });
    }

    // Zelf toevoegen: UpCart onderschept anders de knop en stuurt alleen input[name=id] mee.
    // Een fetch naar cart/add.js pikt UpCart zelf op (drawer opent). Zonder UpCart: naar /cart.
    var busy = false;
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function addToCart(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy || (atcBtn && atcBtn.classList.contains('disabled'))) return;
      busy = true;
      if (atcBtn) atcBtn.classList.add('working');
      var err = form.parentElement.querySelector('.sk__error');
      if (err) err.remove();
      var items = lines(state.list).map(function (l) {
        var it = { id: F[l.handle].variant, quantity: l.qty };
        if (state.sub && plan) it.selling_plan = parseInt(plan, 10);
        return it;
      });
      fetch(root_ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = document.createElement('span');
            msg.className = 'alert alert--error sk__error';
            msg.textContent = res.j.description || res.j.message || 'Er ging iets mis.';
            form.parentElement.appendChild(msg);
            return;
          }
          if (typeof window.upcartOpenCart === 'function') {
            setTimeout(function () {
              if (!document.querySelector('#UpcartPopup.upcartPopupShow')) window.upcartOpenCart();
            }, 900);
          } else {
            window.location.href = root_ + 'cart';
          }
        })
        .catch(function () { window.location.href = root_ + 'cart'; })
        .finally(function () {
          busy = false;
          if (atcBtn) atcBtn.classList.remove('working');
        });
    }
    window.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-js-product-add-to-cart]');
      if (!btn || !form.contains(btn)) return;
      // Cadeau-opties (assets/gift-options.js) voegen eerst hun add-ons toe en klikken daarna opnieuw.
      var gift = page.querySelector('[data-gift-options] [data-gift-wrap]');
      if (gift && gift.checked && !btn.__giftDone) return;
      btn.__giftDone = false;
      addToCart(e);
    }, true);
    window.addEventListener('submit', function (e) {
      if (e.target === form) addToCart(e);
    }, true);

    // USP-blok toont "Verdien X Killer Community punten" op basis van de productprijs: volg het gekozen pakket.
    function updatePoints(n) {
      var text = page.querySelector('.product-text');
      if (!text) return;
      var walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
      var pointsNodes = [];
      while (walker.nextNode()) {
        if (/Verdien\s+\d+/.test(walker.currentNode.nodeValue)) pointsNodes.push(walker.currentNode);
      }
      pointsNodes.forEach(function (node) { node.nodeValue = node.nodeValue.replace(/(Verdien\s+)\d+/, '$1' + n); });
    }

    function add(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      holder.appendChild(input);
    }

    // Galerij wisselen per smaak: slider + thumbnails van het smaakproduct ophalen via Section Rendering
    // (sections/slimming-gallery.liquid) en in de standaard PDP-galerij zetten. Logo's eronder blijven staan.
    var gallery = page.querySelector('[data-js-product-gallery]');
    var galleryCache = {};
    var galleryHandle = state.flavor;
    var swapped = false;
    function fetchGallery(h) {
      if (!galleryCache[h]) {
        galleryCache[h] = fetch(F[h].url + '?section_id=slimming-gallery')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.querySelector('[data-slim-gallery-src]');
            return src ? src.innerHTML : null;
          })
          .catch(function () { delete galleryCache[h]; return null; });
      }
      return galleryCache[h];
    }
    function galleryParts() {
      var parts = [];
      Array.prototype.forEach.call(gallery.children, function (el) {
        if (el.matches('css-slider, .product-gallery__thumbnails, .grid, [data-sk-gpart]')) parts.push(el);
      });
      return parts;
    }
    function showGallery(h) {
      if (!gallery || h === galleryHandle) return;
      galleryHandle = h;
      fetchGallery(h).then(function (html) {
        if (!html || galleryHandle !== h) return;
        var old = galleryParts();
        var anchor = old.length ? old[old.length - 1].nextSibling : gallery.firstChild;
        old.forEach(function (el) { el.remove(); });
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        Array.prototype.slice.call(tmp.children).forEach(function (el) {
          el.setAttribute('data-sk-gpart', '');
          gallery.insertBefore(el, anchor);
        });
        swapped = true;
        var thumbs = gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail');
        if (thumbs[0]) thumbs[0].classList.add('active');
        var slider = gallery.querySelector('css-slider');
        // De slider initialiseert nog los van de pagina (breedte/hoogte 0): na invoegen opnieuw laten meten.
        function remeasure() {
          if (!slider || !slider.isConnected) return;
          if (typeof slider.resetSlider === 'function' && slider.sliderEnabled) slider.resetSlider(true);
          else if (typeof slider.checkSlide === 'function') slider.checkSlide();
        }
        if (slider) {
          requestAnimationFrame(remeasure);
          setTimeout(remeasure, 80);
          setTimeout(remeasure, 600);
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
              if (entries.some(function (en) { return en.isIntersecting; })) { remeasure(); io.disconnect(); }
            });
            io.observe(slider);
          }
        }
        if (slider) slider.addEventListener('change', function (e) {
          gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach(function (t, i) {
            t.classList.toggle('active', i === e.target.index);
          });
        });
      });
    }
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var t = e.target.closest('.product-gallery__thumbnails .thumbnail');
        if (!t || !swapped) return;
        var slider = gallery.querySelector('css-slider');
        if (slider && slider.sliderEnabled) slider.changeSlide(t.dataset.index);
      });
      var prefetch = function () { flavors.forEach(function (f) { if (f.handle !== galleryHandle) fetchGallery(f.handle); }); };
      if ('requestIdleCallback' in window) window.addEventListener('load', function () { requestIdleCallback(prefetch); });
      else window.addEventListener('load', function () { setTimeout(prefetch, 1500); });
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('.sk__tile input')) {
        state.flavor = t.value;
        state.list = fill([], state.packs, state.flavor);
        showGallery(state.flavor);
      } else if (t.matches('.sk__row-main input')) {
        state.packs = parseInt(t.value, 10);
        state.list = fill(state.list, state.packs, state.flavor);
      } else if (t.matches('[data-sk-pack]')) {
        var idx = parseInt(t.dataset.skPack, 10);
        state.list[idx] = t.value;
        if (idx === 0) { state.flavor = t.value; showGallery(state.flavor); }
      } else if (t.matches('[data-sk-sub]')) {
        state.sub = t.checked;
      } else {
        return;
      }
      render();
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-sk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
